// src/pages/admin/PatientsAdminView.jsx
import { useMemo } from "react";
import { DataPageCard, PaginatedTable } from "@common";

export default function PatientsAdminView({
  date,
  data,
  isLoading,
  error,
  page,
  pageSize,
  onPageChange,
  onPageSizeChange,
}) {
  const allDisplayData = useMemo(() => {
    if (!data?.results) return [];

    const result = [];
    data.results.forEach((clinicData) => {
      if (clinicData.patients?.length > 0) {
        clinicData.patients.forEach((patient) => {
          const leadStr = patient.lead || "";
          const leadParts = leadStr.split(" - ", 1);
          const leadCategory = leadParts[0]?.trim() || "";

          result.push({
            clinic: clinicData.clinic,
            name: patient.name || "",
            leadCategory,
          });
        });
      }
    });

    return result;
  }, [data]);

  const totalItems = allDisplayData.length;

  const patientCols = [
    { key: "clinic", header: "CLINIC", nowrap: true },
    { key: "name", header: "PATIENT NAME" },
    { key: "leadCategory", header: "LEAD CATEGORY" },
  ];

  return (
    <DataPageCard
      title="New Patients at a Glance"
      className="mt-6"
      isLoading={isLoading}
      error={error}
      isEmpty={!date || allDisplayData.length === 0}
      loadingMessage="Loading patients data..."
      emptyMessage={
        !date
          ? "Please select a date to view patients data"
          : `No patients data available for ${date}`
      }
      showLoadingSpinner={true}
    >
      <PaginatedTable
        mode="client"
        columns={patientCols}
        data={allDisplayData}
        rowKey={(r, i) => `${r.clinic}-${i}`}
        cellClassName="font-semibold text-palette-slate-primary"
        page={page}
        pageSize={pageSize}
        total={totalItems}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
        pageSizeOptions={[10, 25, 50, 100, 200]}
      />
    </DataPageCard>
  );
}
